/**
 * Make promise cancellable.
 *
 * This prevents you from settting state of an unmounted component.
 *
 * @see https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 */
export function makeCancelable<T>(promise: Promise<T>): CancelablePromise<T> {
  let canceled = false
  const wrappedPromise = new Promise<T>((resolve, reject) => {
    promise
      .then(res => (canceled ? reject({ canceled: true }) : resolve(res)))
      .catch(err => (canceled ? reject({ canceled: true }) : reject(err)))
  })

  return {
    promise: wrappedPromise,
    cancel() {
      canceled = true
    },
  }
}

export interface CancelablePromise<T> {
  promise: Promise<T>
  cancel: () => void
}

/**
 * Get the inner type of an element wrapped in a Promise.
 *
 * https://stackoverflow.com/questions/48011353/how-to-unwrap-type-of-a-promise
 */
export type ThenArg<T> = T extends PromiseLike<infer U> ? U : T
